import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: "d-flex justify-content-center align-items-center flex-1 text-center",
    "active-class": "router-link-active",
    to: _ctx.item.path,
    id: `tab-btn-${_ctx.item.id}`
  }, {
    default: _withCtx(() => [
      _createElementVNode("li", _hoisted_1, [
        _createElementVNode("i", {
          class: _normalizeClass(`sidebar-icon ${_ctx.item.icon}`)
        }, null, 2)
      ])
    ]),
    _: 1
  }, 8, ["to", "id"]))
}